module.exports = __webpack_public_path__ + "static/media/amena.ca0900f6.png";